import moment from 'moment'
import { validateDate, validateTime } from '../lib/validations'

const EMPTY_REPLACEMENTS = {
  date: null,
  time: 'TBC'
}

const isInitted = (originalData, attributeName, value) => {
  return originalData[attributeName] !== value
}

const isUpdated = (originalData, attributeName, value) => {
  return isInitted(originalData, attributeName, value) && originalData[attributeName] !== EMPTY_REPLACEMENTS[attributeName]
}

export default class Treatment {
  constructor (item, index) {
    this.id = index
    this.minDate = moment(item.booking_travel_date)
    this.maxDate = moment(item.booking_return_date)
    this.treatment = item.treatments[this.id]
    this.originalData = item.originalData.treatments[this.id]

    this.treatment.original_date = this.originalData.date
    this.treatment.original_time = this.originalData.time
  }

  update (attributeName, value) {
    if (value === '') {
      value = EMPTY_REPLACEMENTS[attributeName]
    }

    this.treatment[attributeName] = value
    this.treatment.invalid = !this.isValid()
    this.treatment.updated = isUpdated(this.originalData, attributeName, value)
    this.treatment.initted = isInitted(this.originalData, attributeName, value)

    return value
  }

  validate () {
    return {
      ...validateTime(this.id, this.treatment.time, 'treatments', true),
      ...validateDate(this.id, this.treatment.date, this.minDate, this.maxDate, 'treatments', true)
    }
  }

  isValid () {
    const errors = {
      ...this.validate()
    }

    return !Object.keys(errors).length > 0
  }
}
